import React from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Input, Button, Card, Row, Col, Layout, Alert } from "antd";
import { AuthHeader, Form } from "components"
import * as authAction from "actions/auth-action";
import { SoftColor } from "config/constants/Color";
import ReCAPTCHA from "react-google-recaptcha-enterprise";

const mapStateToProps = (state) => ({
    forgot: state.authReducer.forgotReducer
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        ...authAction
    }, dispatch);


const ForgotScreen = (props) => {
    const { forgot, forgotAction } = props;
    const recaptchaRef = React.createRef();
    const [inputType, setInputType] = React.useState('email');
    const [disabled, setDisabled] = React.useState(true);
    const [login, setLogin] = React.useState("")
    const [form] = Form.useForm();

    function onChangeRecaptcha(value) {
        if (value) {
            setDisabled(false)
        }
    }

    const onForgot = async () => {
        const recaptchaValue = recaptchaRef.current.getValue();
        forgotAction(login, inputType, recaptchaValue);
    }

    return (
        <Layout style={{ backgroundColor: SoftColor, height: "100vh", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "row" }}>
            <Layout.Content>
                <Row justify="center" align="middle" className="login">
                    <Col xxl={7} xl={8} lg={12} md={16} sm={24} xs={24}>
                        <Card title={<AuthHeader />} bordered={false} className="card-login">
                            <Form form={form} style={{ width: "100%" }} name="basic" initialValues={{ login: "" }} onFinish={onForgot}>
                                <Form.Item
                                    hasFeedback
                                    name="login"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Insira um e-mail"
                                        },
                                        {
                                            type: "email",
                                            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                            message: "Insira um e-mail válido",
                                        }
                                    ]}>
                                    <Input
                                        autoComplete="off"
                                        prefix={""}
                                        placeholder="E-mail"
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            form.setFieldsValue({
                                                login: value
                                            });
                                            setLogin(value);
                                        }}
                                        value={login}
                                        maxLength={100}
                                        type={"email"}
                                    />
                                </Form.Item>
                                <Form.Item>
                                    <div style={{ width: '100%', justifyContent: 'center', display: 'flex' }}>
                                        <ReCAPTCHA
                                            ref={recaptchaRef}
                                            size="normal"
                                            sitekey={process.env.REACT_APP_CAPTCHA_KEY}
                                            onChange={onChangeRecaptcha}
                                            hl={"pt-BR"}
                                        />
                                    </div>
                                </Form.Item>
                                {forgot.message.length > 0 &&
                                    <Form.Item>
                                        <Alert message={forgot.message} type={forgot.success ? "success" : "error"} showIcon />
                                    </Form.Item>
                                }
                                <Form.Item>
                                    <Button disabled={disabled} loading={forgot.isProcessing} type="primary" htmlType="submit" style={{ width: "100%" }}>Recuperar Senha</Button>
                                </Form.Item>
                                <Form.Item>
                                    <Button type="link" href="/auth/login">Voltar</Button>
                                </Form.Item>
                            </Form>
                        </Card>
                    </Col>
                </Row>
            </Layout.Content>
        </Layout>
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ForgotScreen);
